<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <img src="@/common/images/newsCenter/banner_news.png" class="banner_news" />
    <!-- 占位撑开 -->
    <div class="zwnews"></div>
    <!-- news轮播 -->
    <div class="news_top" id="news">
      <el-carousel :interval="4000" class="carousel" loop arrow="never">
        <el-carousel-item v-for="(item,index) in newsTop" :key="index">
          <div class="newsItem" @click="goDetail(item.id)">
            <img :src="item.coverPlan" class="newsItemImg" />
            <div class="newsItem_r">
              <div class="newsR_top"></div>
              <div class="newsR_time">{{item.createTime | dateFormatY}}</div>
              <div class="newsR_title">{{item.title}}</div>
              <div class="newsR_content">{{item.intro}}</div>
              <div class="newsR_more">more
                <img src="../common/images/newsCenter/more.png" class="more_img" />
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- news选项 -->
    <div class="news_Tbanner">
      <img src="@/common/images/newsCenter/more_b.png" class="more_b" />
      <div class="news_Titem" v-for="(item,index) in item3Banner" :key="index" :class="{'isSelects':item.isSelect}"
        @click="changeItem3(index)">{{item.title}}
        <div class="jg" v-show="index!=2"></div>
      </div>
    </div>
    <!-- news列表 -->
    <div class="news_content" id="news1" v-show="item3Banner[0].isSelect">
      <div class="news_list_item" v-for="(item,index) in news1" :key="index">
        <div class="list_l" @click="goDetail(item.id)">
          <div class="l_title">{{item.title}}</div>
          <div class="l_more">
            more
            <img src="../common/images/newsCenter/more.png" class="more_img" />
          </div>
          <div class="l_content">{{item.intro}}</div>
        </div>
        <div class="list_r">{{item.createTime | dateFormatD}}</div>
      </div>
    </div>
    <div class="news_content" id="news2" v-show="item3Banner[1].isSelect">
      <div class="news_list_item" v-for="(item,index) in news2" :key="index">
        <div class="list_l">
          <div class="l_title">{{item.title}}</div>
          <div class="l_more">
            more
            <img src="../common/images/newsCenter/more.png" class="more_img" />
          </div>
          <div class="l_content">{{item.intro}}</div>
        </div>
        <div class="list_r">{{item.createTime | dateFormatD}}</div>
      </div>
    </div>
    <div class="news_content" id="news3" v-show="item3Banner[2].isSelect">
      <div class="news_list_item" v-for="(item,index) in news3" :key="index">
        <div class="list_l">
          <div class="l_title">{{item.title}}</div>
          <div class="l_more">
            more
            <img src="../common/images/newsCenter/more.png" class="more_img" />
          </div>
          <div class="l_content">{{item.intro}}</div>
        </div>
        <div class="list_r">{{item.createTime | dateFormatD}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import topBanner from '@/components/topBanner.vue'
  export default {
    components: {
      topBanner,
    },
    data() {
      return {
        curPage:'newsCenter',
        newsTop: [{
          coverPlan: require('@/common/images/newsCenter/banner_news.png'),
          createTime: '08/1/2023',
          title: '世界五百强企业 碧桂园集团旗下子公司',
          intro: '经济的发展和人民生活水平的提高,为人居环境提升提出了更高的要求，环境卫生事业发展也进入了“高速快车道”。过去的环卫工作“一个扫把一把锹，手推小车跑断肠”的低标准作业模式，不适应现在的要求。',
          url: ''
        }],
        item3Banner: [{
          title: '公司新闻',
          isSelect: true
        }, {
          title: '通知公告',
          isSelect: false
        }, {
          title: '信息报送',
          isSelect: false
        }],
        news1: [{
          createTime: '08/1',
          title: '世界五百强企业 碧桂园集团旗下子公司',
          intro: '经济的发展和人民生活水平的提高,为人居环境提升提出了更高的要求，环境卫生事业发展也进入了“高速快车道”。过去的环卫工作“一个扫把一把锹，手推小车跑断肠”的低标准作业模式，不适应现在的要求。',

        }],
        news2: [],
        news3: [],
      }
    },

    mounted() {
      this.getNewsTop()
      this.getNewsList()
    },
    methods: {
      changeItem3(e) {
        for (var i = 0; i < 3; i++) {
          this.item3Banner[i].isSelect = false
        }
        this.item3Banner[e].isSelect = true
      },
      getNewsTop() {
        var url = 'http://kjhsx.diandifenlei.com/RecycleBin/news/getNewsHost'
        axios({
          method: 'get',
          url: url
        }).then(({
          data
        }) => {
          if (data.code == 200) {
            console.log(data.data)
            this.newsTop = data.data
          }
        })
      },
      getNewsList() {
        var url = 'http://kjhsx.diandifenlei.com/RecycleBin/news/getNewsList'
        axios({
          method: 'get',
          url: url,
          params: {
            page: 1
          }
        }).then(({
          data
        }) => {
          console.log(data)
          if (data.code == 200) {
            console.log(data.data.data)
            this.news1 = data.data.data
          }
        })
      },
      goDetail(e) {
        this.$router.push({
          path: '/newsDetail',
          query:{
            id:e
          }
        })
      },
    },
  }
</script>

<style>
  .container {
    position: relative;
  }

  .banner_news {
    width: 1920px;
    height: 900px;
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zwnews {
    width: 1920px;
    height: 900px;
  }

  .news_top {
    width: 1280px;
    height: 580px;
    background-color: #fff;
    padding: 100px 320px;
  }

  .carousel {
    width: 1280px;
    height: 520px;
  }

  #news .el-carousel__container {
    width: 1280px;
    height: 520px;
  }

  .newsItem {
    width: 1280px;
    height: 400px;
    text-align: center;
    display: flex;
    flex-direction: row;
    cursor: pointer;
  }

  .newsItemImg {
    width: 680px;
    height: 380px;
    margin-right: 20px;
  }

  .newsItem_r {
    width: 580px;
    height: 400px;
    display: flex;
    flex-direction: column;
    position: relative;
    color: #000;
  }

  .newsR_top {
    width: 80px;
    height: 16px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #005e9e;
  }

  .newsR_time {
    font-size: 36px;
    line-height: 48px;
    position: absolute;
    top: 52px;
    left: 0;
  }

  .newsR_title {
    width: 580px;
    font-size: 32px;
    height: 42px;
    line-height: 42px;
    position: absolute;
    top: 120px;
    left: 0;
    color: #005e9e;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .newsR_content {
    font-size: 20px;
    line-height: 32px;
    width: 580px;
    height: 128px;
    text-align: left;
    position: absolute;
    top: 172px;
    left: 0;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    /* text-indent: 2em; */
  }

  .newsR_more {
    width: 128px;
    height: 42px;
    font-size: 34px;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 999;
    color: #000;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .more_img {
    width: 36px;
    height: 8px;
  }

  #news .el-carousel__button {
    width: 26px !important;
    height: 26px !important;
    border-radius: 13px !important;
    background-color: #bfbfbf !important;
    /* border: 3px solid #005e9e !important; */
    opacity: 1;
  }

  #news .is-active .el-carousel__button {
    background-color: #005e9e !important;
    opacity: 1;
  }

  .news_Tbanner {
    position: absolute;
    top: 1580px;
    left: 200px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .news_Titem {
    font-size: 34px;
    padding: 0 32px;
    font-weight: 100;
    position: relative;
    cursor: pointer;
  }

  .more_b {
    width: 72px;
    height: 36px;
    margin-right: 32px;
  }

  .jg {
    width: 2px;
    height: 12px;
    position: absolute;
    background-color: #8c8c8c;
    top: 20px;
    right: 0;
  }

  .isSelects {
    color: #005e9e;
  }

  .news_content {
    width: 1120px;
    min-height: 300px;
    padding: 80px 400px;
    background-color: #f0f0f0;
  }

  .news_list_item {
    width: 1120px;
    height: 280px;
    margin-bottom: 60px;
    position: relative;
    display: flex;
    flex-direction: row;
  }

  .list_l {
    width: 940px;
    height: 220px;
    padding: 30px 40px;
    background-color: #fff;
    color: #000;
    position: relative;
  }

  .l_title {
    width: 820px;
    height: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 30px;
    line-height: 72px;
    color: #005e9e;
  }

  .l_more {
    font-size: 28px;
    position: absolute;
    top: 40px;
    right: 40px;
    cursor: pointer;
  }

  .l_content {
    font-size: 20px;
    line-height: 36px;
    width: 860px;
    height: 112px;
    text-align: left;
    position: absolute;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  .list_r {
    width: 52px;
    height: 80px;
    padding: 14px 0px;
    line-height: 28px;
    background-color: #005e9e;
    color: #fff;
    font-size: 32px;
    word-break: break-all;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/newsCenter.vue